import { CoreChip } from "@verity/components/core";
import i18n from "../../../../../i18n";

const SESSION_STATUS = ["flagged", "unflagged", "incomplete", "unavailable", "pending", "error"] as const;

type SessionStatus = (typeof SESSION_STATUS)[number];

const sessionStatusConfig: Record<SessionStatus, { color: string; text: string }> = {
	flagged: { color: "#DFF2F2", text: i18n.t("result.components.studentSelection.selectionMenuTSX.complete") },
	unflagged: { color: "#DFF2F2", text: i18n.t("result.components.studentSelection.selectionMenuTSX.complete") },
	incomplete: { color: "#F9E4F5", text: i18n.t("result.components.studentSelection.selectionMenuTSX.incomplete") },
	unavailable: { color: "#F8E4DD", text: i18n.t("result.components.studentSelection.selectionMenuTSX.unavailable") },
	pending: { color: "#E4E3F6", text: i18n.t("result.components.studentSelection.selectionMenuTSX.pending") },
	error: { color: "#E6E6E6", text: i18n.t("result.components.studentSelection.selectionMenuTSX.error") },
};

function isSessionStatus(status: string | null | undefined): status is SessionStatus {
	if (!status) return false;
	return SESSION_STATUS.includes(status as SessionStatus);
}

type SessionStatusChipProps = {
	status?: string | null;
	isLate?: boolean;
};

export default function SessionStatusChip({ status, isLate = false }: SessionStatusChipProps) {
	const cleanedStatus = isSessionStatus(status) ? status : "error";
	const config = sessionStatusConfig[cleanedStatus];

	const lateText = i18n.t("result.components.studentSelection.selectionMenuTSX.late");
	return (
		<CoreChip
			chipColor={isLate ? sessionStatusConfig["unavailable"].color : config.color}
			variant="rectangular"
			sx={{
				width: "fit-content",
				height: "28px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				textAlign: "center",
			}}
		>
			{config.text}
			{isLate && <> {lateText}</>}
		</CoreChip>
	);
}
